const features = [
  {
    icon: 'ri-4k-line',
    title: '4K超清画质',
    description: '支持4K超清画质播放，HDR技术加持，每一帧都清晰细腻，带来影院级观影体验',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    description: '全球CDN加速节点覆盖，智能码率调节技术，根据网络状况自动优化，看视频不卡顿',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多终端支持',
    description: '电脑、手机、平板、智能电视全平台覆盖，一个账号多设备同步，随时随地想看就看',
  },
  {
    icon: 'ri-shield-check-line',
    title: '正版内容',
    description: '与众多内容提供商建立正式合作，所有视频内容均获合法授权，安全可靠放心看',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存',
    description: '支持视频离线缓存功能，提前下载好想看的内容，没有网络也能畅快追剧',
  },
  {
    icon: 'ri-user-heart-line',
    title: '完全免费',
    description: '所有视频内容完全免费观看，无需付费订阅，让每个人都能享受高品质的视频服务',
  },
];

export default function Features() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            为什么选择黄瓜视频在线
          </h2>
          <p className="text-sm text-foreground-500">六大优势，重新定义免费在线观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex gap-4 p-5 bg-background-50 rounded-xl transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base text-foreground-900 mb-1.5">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}